/**
 * Bundle Image Accordion - Sticky Scroll
 * seamless scroll effect where scroll progress drives the active slide.
 */

const initAccordion = () => {
    const section = document.querySelector('.bundle-accordion');
    const items = document.querySelectorAll('.bundle-accordion__item');

    if (!section || !items.length) return;

    let isMobile = window.innerWidth <= 768;

    // Global handlers for cleanup
    if (window.accordionScrollHandler) {
        window.removeEventListener('scroll', window.accordionScrollHandler);
    }
    if (window.accordionResizeHandler) {
        window.removeEventListener('resize', window.accordionResizeHandler);
    }

    // Update isMobile on resize
    function handleResize() {
        const wasMobile = isMobile;
        isMobile = window.innerWidth <= 768;
        if (!isMobile && wasMobile) {
            handleScroll();
        }
    }

    window.accordionResizeHandler = handleResize;
    window.addEventListener('resize', handleResize);

    function activateItem(index) {
        items.forEach((item, i) => {
            if (i === index) {
                item.classList.add('is-active');
            } else {
                item.classList.remove('is-active');
            }
        });
    }

    function handleScroll() {
        if (!section) return;
        const rect = section.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const sectionHeight = rect.height;
        const availableScroll = sectionHeight - viewportHeight;
        const scrolled = -rect.top;

        let progress = 0;
        if (scrolled < 0) {
            progress = 0;
        } else if (scrolled > availableScroll) {
            progress = 1;
        } else {
            progress = scrolled / availableScroll;
        }

        const totalItems = items.length;
        const segmentSize = 1 / totalItems;
        let activeIndex = Math.floor(progress / segmentSize);

        if (activeIndex < 0) activeIndex = 0;
        if (activeIndex >= totalItems) activeIndex = totalItems - 1;

        activateItem(activeIndex);
    }

    window.accordionScrollHandler = handleScroll;
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    // Fallback/Interaction for click
    items.forEach((item, index) => {
        item.addEventListener('click', () => {
            if (isMobile) {
                // For mobile, we might want to allow toggling or exclusive accordion behavior
                // The current logic enforces one active item at a time
                items.forEach(i => i.classList.remove('is-active'));
                item.classList.add('is-active');
            } else {
                activateItem(index);
            }
        });
    });
};

document.addEventListener('DOMContentLoaded', initAccordion);

// Theme Editor Support
document.addEventListener('shopify:section:load', (e) => {
    if (e.target.classList.contains('bundle-accordion') || e.target.querySelector('.bundle-accordion')) {
        initAccordion();
    }
});

document.addEventListener('shopify:block:select', (e) => {
    const blockItem = e.target.closest('.bundle-accordion__item');
    if (blockItem) {
        const items = document.querySelectorAll('.bundle-accordion__item');
        const index = Array.from(items).indexOf(blockItem);

        // Temporarily activate the selected block in editor
        items.forEach(i => i.classList.remove('is-active'));
        blockItem.classList.add('is-active');
    }
});
